import React from 'react'
import ComponentsTable from './ComponentsTable'
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle'
import { useSelector } from 'react-redux'

const ComponentsSection = () => {
    const assignmentName = useSelector(state => state.assignment.assignment_name)
    useDocumentTitle(`${assignmentName || ''} Components`)

    return <ComponentsTable />
}

export default ComponentsSection
